<template>
  <div class="MonthWorkDetails">
     <!-- <v-card> -->
      <div
          v-if="personelName"
          class="text-color-black mb-3 "
          style="font-size: 1.3rem"
        >
          {{ personelName }}
        </div>
    <!-- </v-card> -->
    <v-card>
      <v-tabs dark background-color="primary " show-arrows>
        <v-tabs-slider color="accent"></v-tabs-slider>

        <v-tab
          class="text-caption"
          v-for="(tab, index) in tabs"
          :key="index"
          :href="'#' + tab.id"
        >
          <span class="font-sahel">{{ $t(tab.title) }}</span>
        </v-tab>

        <v-tab-item value="totalIO">
          <full-period-io-info :args="args" />
        </v-tab-item>
        <v-tab-item value="totalMorakhasi">
          <person-vacation-list :args="args" />
        </v-tab-item>
        <v-tab-item value="totalMissions">
          <person-mission-list :args="args" />
        </v-tab-item>
        <v-tab-item value="detailsFunctionality">
          <functinality-details-tab :args="args" />
        </v-tab-item>
        <v-tab-item v-if="!DisableShowingMorLeft" value="detailsMorakhasi">
          <vacation-details :args="args" />
        </v-tab-item>
      </v-tabs>
    </v-card>

    <div class="mt-2" v-if="details">
      <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel v-for="(item, i) in items" :key="i" class="mt-1">
          <v-card>
            <v-expansion-panel-header color="primary" class="box-title px-2">
              {{ $t(item.title) }}
              <template v-slot:actions>
                <v-icon color="#f2f2f2"> $expand </v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content
              class="content pa-2 ma-0"
              style="background: var(--background-card) !important"
            >
              <div>
                <keep-alive>
                  <component
                    :is="item.content"
                    v-bind="detailsProps"
                  ></component>
                </keep-alive>
              </div>
            </v-expansion-panel-content>
          </v-card>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <div class="d-flex py-1">
      <v-spacer></v-spacer>
      <v-btn outlined color="primary" v-if="visiblePrint" @click="print">
        <v-icon left>mdi-printer</v-icon>
        <span class=""> پرینت ورود خروج </span>
      </v-btn>
      <!-- <v-spacer></v-spacer> -->
      <v-btn outlined color="primary" v-if="visiblePrint" @click="printDateil">
        <v-icon left>mdi-printer</v-icon>
        <span class=""> پرینت محاسبات </span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import FunctionalDetails from "../../components/functionality/periodDetails/FunctionalDetails.vue";
import KasrKarDetails from "../../components/functionality/periodDetails/KasrKarDetails.vue";
import ExtraWorkDetails from "../../components/functionality/periodDetails/ExtraWorkDetails.vue";
import MorakhasiDetails from "../../components/functionality/periodDetails/MorakhasiDetails.vue";
import MamoriatDetails from "../../components/functionality/periodDetails/MamoriatDetails.vue";
import HolidayDetails from "../../components/functionality/periodDetails/HolidayDetails.vue";
import FullPeriodIoInfo from "../../components/functionality/periodDetails/FullPeriodIoInfo/FullPeriodIoInfo.vue";
import PersonVacationList from "../../components/functionality/periodDetails/PersonVacationList/PersonVacationList.vue";
import VacationDetails from "../../components/functionality/periodDetails/VacationDetails/VacationDetails.vue";
import PersonMissionList from "../../components/functionality/periodDetails/PersonMissionList/PersonMissionList.vue";
import FunctinalityDetailsTab from "../../components/functionality/periodDetails/FunctinalityDetailsTab/FunctinalityDetailsTab.vue";
import EosToastType from "../../model/EosToastType";
import EosUtils from "../../utils/EosUtils";

export default {
  components: {
    FullPeriodIoInfo,
    PersonVacationList,
    PersonMissionList,
    VacationDetails,
    FunctinalityDetailsTab,
  },
  mounted() {
    this.args.year = this.$route.params.year;
    this.args.month = this.$route.params.month;
    this.args.period = this.$route.params.month;
    this.args.perno = this.$route.params.perno;
    this.pageLoad();
    this.GetPersonMonthWorkDetail();
    this.checkVisiblePrint();
    this.getPersonelName();
  },
  computed: {
    detailsProps() {
      return { details: this.details };
    },
  },
  methods: {
    pageLoad() {
      this.$store.dispatch("readwebkartsetting").then((result) => {
        if (result.type === "success") {
          //
          if (result.data.DisableShowingMorLeft === "1") {
            this.DisableShowingMorLeft = true;
            var detailsMorakhasiIndex = this.tabs.findIndex(
              (item) => item.id === "detailsMorakhasi"
            );
            console.log(detailsMorakhasiIndex);
            if (detailsMorakhasiIndex != -1) {
              this.tabs.splice(detailsMorakhasiIndex, 1);
            }
          } else {
            this.DisableShowingMorLeft = false;
            this.tabs.push({
              id: "detailsMorakhasi",
              title: "PeriodWorkDetails.tabs.detailsMorakhasi.title",
            });
          }
        }
      });
    },
    getPersonelName() {
      //debugger
      const params = new URLSearchParams();
      if (this.args.perno) {
        params.append("perno", this.args.perno);
      }
      this.$store
        .dispatch("GetPersonFullName", { params })
        .then((result) => {
          //debugger
          ////console.log(result);
          if (result.type === "success") {
            if (result.data.length > 0) {
              // this.personelName= result.data
              this.personelName = result.data+' - ' + 'با شماره پرسنلی '+"( " + this.args.perno + " )";
            }
          }
        });
    },
    /*GetPeriodBeginAndEndDate() {
      const params = new URLSearchParams();
      params.append("periodNumber", this.args.month);
      params.append("year", this.args.year);
      if (this.args.perno) {
        params.append("employeeId", this.args.perno);
      }
      
      this.$store
        .dispatch("GetPeriodBeginAndEndDate", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            if (result.data.length > 0) {
              let data = result.data[0];
              this.GetPersonPeriodWorkDetail(data.Type);
            }
          }
        });
    },*/
    GetPersonMonthWorkDetail() {
      const params = new URLSearchParams();
      params.append("period", this.args.month);
      params.append("year", this.args.year);
      params.append("isPeriod", false);
      if (this.args.perno) {
        params.append("perno", this.args.perno);
      }

      this.$store
        .dispatch("GetPersonPeriodWorkDetail", { params })
        .then((result) => {
          //console.log(result);
          if (result.type === "success") {
            //debugger;
            this.details = result.data.Table[0];
            this.details.year = this.args.year;
            this.details.isPeriod = false;
            this.details.PERIOD = this.args.month;
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
          }
        });
    },
    checkVisiblePrint() {
      if (EosUtils.isWebKartAdmin()) {
        this.visiblePrint = true;
      } else {
        var canPrint = false;

        var adminPermissionList =
          this.$store.state.personel.personelDetail.AdminPermission.Table;
        adminPermissionList.every((element) => {
          var adminPermission = element.adminPermission;
          if (adminPermission && adminPermission[50].toString() == "1") {
            this.visiblePrint = true;
            canPrint = true;
            return false;
          }
          return true;
        });

        if (!canPrint) {
          var permission = this.$store.state.personel.personelDetail.Permission;
          if (permission[19].toString() == "1") {
            this.visiblePrint = true;
          }
        }
      }
    },
    print() {
      var dp = "";
      if (this.args.perno) {
        dp = this.args.perno;
      } else {
        dp = this.$store.state.auth.auth.username;
      }

      let routeData = this.$router.resolve({
        name: "rpPersonelPeriodWorkDetail",
        query: { Y: this.args.year, P: this.args.month, POM: "M", dp: dp },
      });
      window.open(routeData.href, "_blank");
    },
    printDateil(){
      var dp = "";
      if (this.args.perno) {
        dp = this.args.perno;
      } else {
        dp = this.$store.state.auth.auth.username;
      }

      let routeData = this.$router.resolve({
        name: "rpPersonelPeriodWorkDetail",
        query: { Y: this.args.year, P: this.args.month, POM: "M", dp: dp ,details:"true"},
      });
      window.open(routeData.href, "_blank");

    },
  },
  data() {
    return {
      visiblePrint: false,
      args: {},
      details: {},
      DisableShowingMorLeft: true,
      personelName:'',
      tabs: [
        { id: "totalIO", title: "PeriodWorkDetails.tabs.totalIO" },
        {
          id: "totalMorakhasi",
          title: "PeriodWorkDetails.tabs.totalMorakhasi",
        },
        { id: "totalMissions", title: "PeriodWorkDetails.tabs.totalMissions" },
        {
          id: "detailsFunctionality",
          title: "PeriodWorkDetails.tabs.detailsFunctionality.title",
        },
      ],
      panel: [0,1,2,3,4,5],
      items: [
        {
          title: "PeriodWorkDetails.FunctionalDetails.title",
          content: FunctionalDetails,
        },
        {
          title: "PeriodWorkDetails.KasrKarDetails.title",
          content: KasrKarDetails,
        },
        {
          title: "PeriodWorkDetails.ExtraWorkDetails.title",
          content: ExtraWorkDetails,
        },
        {
          title: "PeriodWorkDetails.MorakhasiDetails.title",
          content: MorakhasiDetails,
        },
        {
          title: "PeriodWorkDetails.MamoriatDetails.title",
          content: MamoriatDetails,
        },
        {
          title: "PeriodWorkDetails.HolidayDetails.title",
          content: HolidayDetails,
        },
      ],
    };
  },
};
</script>

<style>
.periodWorkDetail .content * {
  padding: 0px 0px !important;
}
</style>